import { cn } from '@/lib/utils';

interface VolumeBadgeImageProps {
  src: string;
  alt: string;
  className?: string;
  /** Visual size preset */
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASS: Record<NonNullable<VolumeBadgeImageProps['size']>, string> = {
  sm: 'h-8 w-auto max-w-[4.5rem]',
  md: 'h-12 w-auto max-w-[7rem]',
  lg: 'h-16 w-auto max-w-[9rem]',
};

/**
 * Renders designed volume badge artwork from /badges/volume/*.png
 */
export function VolumeBadgeImage({ src, alt, className, size = 'md' }: VolumeBadgeImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn('object-contain drop-shadow-sm', SIZE_CLASS[size], className)}
      loading="lazy"
      decoding="async"
    />
  );
}

export default VolumeBadgeImage;
